import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractLabel} from "../../../labels/abstract-label";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-pill-label",
    styleUrls: ["./pill-label.component.scss"],
    templateUrl: "./pill-label.component.html",
    standalone: false
})
export class FUIPillLabelComponent extends FUIAbstractLabel {
}
